import { css } from "@emotion/react";
import { CustomScrollbars } from "@/components/CustomScrollbars/CustomScrollbars";
import { ResetPasswordForm } from "@/components/ResetPasswordForm";
import { SiteLayout } from "@/components/SiteLayout";
import { AppConstants } from "@/data/AppConstants";
import { useTranslate } from "@/hooks/useTranslate/useTranslate";

export const ResetPasswordPage = () => {
	const translate = useTranslate();

	return (
		<SiteLayout
			title={translate("Reset Password")}
			mainChildren={
				<CustomScrollbars className="flex-1 flex items-center justify-center">
					<div
						className={`flex-1 mx-auto flex items-center justify-center]`}
						css={css`max-width:${AppConstants.siteWidthCss};`}
					>
						<ResetPasswordForm />
					</div>
				</CustomScrollbars>
			}
		/>
	);
};
